import { ContentCard } from "sj-ui-toolkit/src/atlas/components";

export const LessonsContainer = ({ title, lessons = [], inPath = false, disabled = false }) => {
  const sectionId = `lessons-section-${title.toLowerCase().replace(/\s+/g, "-")}`;

  return (
    <section className="py-8" aria-labelledby={sectionId}>
      <h2 className="atlas-h5" id={sectionId}>
        {title}
      </h2>
      <ul className="flex flex-wrap gap-6 mt-4 list-none p-0 m-0" role="list">
        {lessons.map(lesson => (
          <li key={lesson.id}>
            <ContentCard
              {...lesson}
              inPath={inPath}
              type="lesson"
              disabled={disabled}
              headingLevel="h3"
            />
          </li>
        ))}
      </ul>
    </section>
  );
};
